// Cookie Consent Types and Interfaces

export type ConsentCategory = 'essential' | 'analytics' | 'marketing';
export type ConsentStatus = 'granted' | 'denied' | 'pending';

export interface CookieConsent {
  essential: ConsentStatus;  // Always granted (required for site functionality)
  analytics: ConsentStatus;  // Google Analytics tracking
  marketing: ConsentStatus;  // Future marketing/email campaigns (not currently used)
  timestamp: number;         // When consent was given (milliseconds since epoch)
  version: string;           // Consent version for policy updates
  expires?: number;          // Optional: when consent expires (12 months from timestamp)
}

// Consent update payload for partial updates
export interface ConsentUpdate {
  essential?: ConsentStatus;
  analytics?: ConsentStatus;
  marketing?: ConsentStatus;
  timestamp?: number;
  version?: string;
}

// Banner visibility states
export type BannerState = 'hidden' | 'minimized' | 'expanded';

// Consent preferences for UI display
export interface ConsentPreference {
  id: ConsentCategory;
  title: string;
  description: string;
  required: boolean;
  defaultValue: ConsentStatus;
}

// Consent event tracking
export interface ConsentEvent {
  action: 'given' | 'revoked' | 'updated' | 'banner_shown' | 'banner_hidden';
  category: ConsentCategory | 'all';
  timestamp: number;
  previousStatus?: ConsentStatus;
  newStatus?: ConsentStatus;
}

// Validation result for consent data
export interface ConsentValidation {
  isValid: boolean;
  reason?: string;
  needsRenewal?: boolean;
}

// Default consent preferences configuration
export const CONSENT_PREFERENCES: ConsentPreference[] = [
  {
    id: 'essential',
    title: 'Essential Cookies',
    description: 'Required for the website to function properly. These include security features and basic site functionality. Cannot be disabled.',
    required: true,
    defaultValue: 'granted',
  },
  {
    id: 'analytics',
    title: 'Analytics Cookies',
    description: 'Help us understand how visitors interact with our website through Google Analytics. We use this data to improve our services. Anonymous data only.',
    required: false,
    defaultValue: 'granted', // Granted by default for better insights
  },
  {
    id: 'marketing',
    title: 'Marketing Cookies',
    description: 'Would be used for future email campaigns or promotional content. Currently not in use.',
    required: false,
    defaultValue: 'denied', // Denied by default
  },
];
